<template>
  <thead class="bg-gray-50">
    <tr>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider flex-1"
      >
        SMS Message
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider w-32 text-left"
      >
        Status
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider w-48 text-left"
      >
        Starts at
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider w-32 text-right"
      >
        Date Created
      </th>
    </tr>
  </thead>
</template>

<script>
export default {};
</script>
